<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-form-group
          :label="$lang.final_report_vote_options"
          label-for="vote_options"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.final_report_vote_options"
            :rules="$v.vote_selected.$params"
          />
          <selectFind
            :options="vote_options"
            v-model="$v.vote_selected.$model"
            label="text"
            id="value"
            :isValid="$v.vote_selected.$dirty ? !$v.vote_selected.$error : null"
          />
          <b-form-invalid-feedback
            :style="{
              display: $v.vote_selected.$error ? 'block' : 'none',
            }"
            id="vote_selected_feedback"
          >
            {{
              $lang.error_required | replace($lang.final_report_vote_options)
            }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          :label="$lang.final_report_vote_description"
          label-for="description"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.final_report_vote_description"
            :rules="$v.description.$params"
          />
          <b-form-textarea
            type="text"
            v-model="$v.description.$model"
            :rows="this.$config.form.textareaRows"
          >
          </b-form-textarea>
          <b-form-invalid-feedback id="description-feedback">
            {{
              $lang.error_required
                | replace($lang.final_report_vote_description)
            }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" class="text-right">
        <b-button variant="success" @click="submit">
          {{ $lang.submitButton }}
          <i class="fa fa-check"></i>
        </b-button>
        <b-button
          type="reset"
          class="ml-2"
          size="md"
          variant="danger"
          @click="closeModal"
        >
          {{ $lang.cancelButton }}
          <i class="fa fa-ban"></i>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { renderEumOptions } from "@/shared/utils";
import { pathOr } from "ramda";
import { required } from "vuelidate/lib/validators";

export default {
  validations: {
    vote_selected: { required },
    description: {},
  },
  props: {
    mode: {
      type: String,
      default: "",
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      vote_selected: null,
      description: null,
    };
  },
  computed: {
    vote_options() {
      return renderEumOptions("final_report_vote");
    },
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        this.isLoading = false;
        return;
      }
      const payload = {
        vote: pathOr(null, ["value"], this.vote_selected),
        description: this.description,
      };
      this.$emit("submit", payload);
    },

    closeModal() {
      this.$emit("closeModal");
    },

    fetchData() {
      this.vote_selected = this.vote_options.find(
        (x) => x.value === pathOr(null, ["vote", "id"], this.item)
      );
      this.description = pathOr(null, ["description"], this.item);
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
